import React from 'react';
import PropTypes from 'prop-types';

import Pficon from 'components/Pficon';

const FieldCheck = ({ checked = false }) => (
  <span
    className="position-absolute pointer-events-none"
    style={{
      zIndex: 2,
      top: '50%',
      right: '10px',
      transform: 'translate3d(0, -50%, 0)',
      fontSize: '20px',
      marginTop: '1px',
    }}
  >
    {checked && <Pficon type="check-material" style={{ color: '#13ce66' }} />}
  </span>
);

FieldCheck.propTypes = {
  checked: PropTypes.bool,
};

export default FieldCheck;
